import React, { useMemo } from 'react';

import Typography from '@ts-core/components/Typography';

interface QuestionScoreProps {
  score?: number;
  noAnswer?: boolean;
}

const QuestionScore = (props: QuestionScoreProps) => {
  const { score, noAnswer = false } = props;
  const scoreType = useMemo(() => {
    if (score === undefined || noAnswer) {
      return 'none';
    }
    if (score > 0) {
      return 'positive';
    }
    if (score < 0) {
      return 'negative';
    }
    return 'neutral';
  }, [score, noAnswer]);

  const scoreText = useMemo(() => {
    if (!score) {
      return '+0';
    }
    const formattedScore = Number.isInteger(score) ? score : score.toFixed(2);
    return `${formattedScore < 0 ? '' : '+'}${formattedScore}`;
  }, [score]);

  return (
    <Typography
      sx={(theme) => ({
        fontSize: 100,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '20%',
        opacity: 0.5,
        color: theme.check.palette.exercise.color(scoreType),
        [theme.breakpoints.down('sm')]: {
          fontSize: 64,
        },
      })}
    >
      {scoreText}
    </Typography>
  );
};

export default QuestionScore;
